export default {
	data() {
		return {
			loginPor: {
				cpf: true,
				login: false,
			},
		}
	},
	created() {
		this.encontrarCampoLoginPor()
	},
	methods: {
		encontrarCampoLoginPor() {
			Object.keys(this.loginPor).forEach((index) => {
				this.loginPor[index] = window.$cliente.get('login') === index
			})
		},
	},
}
